import { request } from '../../utils/request';
import { pandoraRequest } from '../../utils/pandoraRequest';

export async function getUserAllRoundRecord(stage = 2) {
  return request({
    method: 'get',
    url: '/super_brain/user_all_round_record/' + stage,
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  });
}

export async function getUserAllRoundRecordByCode(code) {
  return request({
    method: 'get',
    url: '/super_brain/share/' + code,
  });
}

export function getReferralCode() {
  return request({
    method: 'get',
    url: '/super_brain/referrer_code',
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  });
}

export function getUserPoint(addr) {
  return pandoraRequest({
    method: 'get',
    url: '/answer/getAccountInfo?address=' + addr,
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  });
}

export function getStakeSign(data) {
  return pandoraRequest({
    method: 'post',
    url: '/answer/registerSign',
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
    data: {
      ...data,
    },
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  });
}

export function getRoundReferralRecord(roundId) {
  return request({
    method: 'get',
    url: '/super_brain/referrer/' + roundId,
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
  });
}

export async function getUserRoundInfo(roundId) {
  return request({
    method: 'get',
    url: '/super_brain/user_round_info',
    headers: {
      Authorization: sessionStorage.getItem('superAvatarAuthToken')
    },
    params: {
      round_id: roundId,
      chain_id: process.env.VUE_APP_ENV == 'dev' ? '97' : '56'
    }
  });
}

export async function getUserRoundRecord(roundId) {
  return request({
    method: 'get',
    url: '/super_brain/user_round_record/' + roundId,
  });
}

export function getDelayWs() {
  let ws = new WebSocket(process.env.VUE_APP_WS_BASE_URL + "/wsping");
  return ws;
}